import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, vShow as _vShow, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex h-full w-full flex-col bg-white overflow-hidden transition-all duration-300",
  role: "region",
  "aria-label": "AI Section Editor"
}
const _hoisted_2 = { class: "flex items-center justify-between border-b border-[#e2e8f0] px-5 py-3.5 bg-gradient-to-r from-[#f8fbff] to-[#f0f7ff]" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-tr from-[#0f3557] to-[#2563eb] text-white shadow-sm shrink-0" }
const _hoisted_5 = { class: "min-w-0" }
const _hoisted_6 = { class: "text-sm font-extrabold text-[#0f172a] truncate" }
const _hoisted_7 = { class: "flex-1 overflow-y-auto p-4 space-y-4" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-start gap-2.5 rounded-xl border border-amber-200 bg-amber-50/90 p-3 text-[11px] text-amber-900"
}
const _hoisted_9 = { class: "space-y-1" }
const _hoisted_10 = { class: "flex items-center justify-between" }
const _hoisted_11 = {
  key: 0,
  class: "inline-flex items-center gap-1 rounded-md bg-emerald-50 px-2 py-0.5 text-[10px] font-bold text-emerald-700 border border-emerald-200"
}
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  label: "Cloud OpenAI Models"
}
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 1,
  label: "Local Ollama Models"
}
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "rounded-xl border border-[#e2e8f0] bg-[#fafcff] overflow-hidden" }
const _hoisted_19 = { class: "flex items-center gap-1.5" }
const _hoisted_20 = {
  key: 0,
  class: "rounded bg-[#dbeafe] px-1.5 py-0.2 text-[9.5px] text-[#1e40af]"
}
const _hoisted_21 = { class: "border-t border-[#e2e8f0] p-3 space-y-2 bg-white" }
const _hoisted_22 = { class: "flex items-center justify-end" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "space-y-2" }
const _hoisted_25 = { class: "flex flex-wrap gap-1.5" }
const _hoisted_26 = ["disabled", "onClick"]
const _hoisted_27 = { class: "flex flex-wrap gap-1.5" }
const _hoisted_28 = ["disabled", "onClick"]
const _hoisted_29 = { class: "space-y-1.5" }
const _hoisted_30 = { class: "flex items-center justify-between" }
const _hoisted_31 = { class: "text-[10px] text-[#94a3b8]" }
const _hoisted_32 = { class: "relative" }
const _hoisted_33 = { class: "absolute right-2.5 top-2.5 z-10 flex items-center gap-1.5" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["disabled", "onKeydown"]
const _hoisted_36 = {
  key: 1,
  class: "flex items-center gap-3 rounded-xl border border-[#bfdbfe] bg-[#eff6ff] p-3.5 text-xs font-bold text-[#1e40af] animate-pulse"
}
const _hoisted_37 = { class: "flex-1" }
const _hoisted_38 = {
  key: 2,
  class: "flex items-start gap-2.5 rounded-xl border border-red-200 bg-red-50 p-3 text-xs text-red-900"
}
const _hoisted_39 = { class: "flex-1" }
const _hoisted_40 = { class: "mt-0.5 text-[11px] text-red-700" }
const _hoisted_41 = {
  key: 3,
  class: "flex items-start gap-2.5 rounded-xl border border-amber-200 bg-amber-50 p-3 text-xs text-amber-900"
}
const _hoisted_42 = { class: "flex-1 text-[11px]" }
const _hoisted_43 = { class: "border-t border-[#e2e8f0] pt-3 space-y-2" }
const _hoisted_44 = { class: "flex items-center justify-between" }
const _hoisted_45 = { class: "flex items-center gap-1.5 text-[11px] font-extrabold text-[#334155] uppercase tracking-wider" }
const _hoisted_46 = { class: "flex items-center gap-2" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  key: 0,
  class: "text-center py-2 text-xs text-[#94a3b8]"
}
const _hoisted_49 = {
  key: 1,
  class: "rounded-lg border border-dashed border-[#e2e8f0] p-2.5 text-center text-[11px] text-[#94a3b8]"
}
const _hoisted_50 = {
  key: 2,
  class: "space-y-1.5 max-h-36 overflow-y-auto pr-1"
}
const _hoisted_51 = { class: "space-y-0.5 min-w-0 pr-2" }
const _hoisted_52 = { class: "flex items-center gap-1.5 font-bold text-[#0f172a] text-[11px]" }
const _hoisted_53 = {
  key: 0,
  class: "rounded bg-[#2563eb] px-1 py-0.1 text-[9px] text-white"
}
const _hoisted_54 = { class: "text-[10px] font-normal text-[#64748b]" }
const _hoisted_55 = ["title"]
const _hoisted_56 = { class: "flex items-center gap-2 shrink-0" }
const _hoisted_57 = ["disabled", "onClick"]
const _hoisted_58 = { class: "text-[9.5px] text-[#94a3b8]" }
const _hoisted_59 = { class: "border-t border-[#e2e8f0] bg-[#f8fbff] px-4 py-3" }
const _hoisted_60 = { class: "flex items-center justify-between gap-2" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { class: "flex items-center gap-1.5" }
const _hoisted_64 = ["disabled"]
const _hoisted_65 = {
  key: 0,
  class: "absolute inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4 backdrop-blur-xs"
}
const _hoisted_66 = { class: "w-full max-w-xs rounded-2xl border border-[#e2e8f0] bg-white p-4 shadow-2xl space-y-3" }
const _hoisted_67 = { class: "flex items-start gap-3" }
const _hoisted_68 = { class: "space-y-1 min-w-0" }
const _hoisted_69 = { class: "text-xs font-extrabold text-[#0f172a]" }
const _hoisted_70 = { class: "text-[11px] leading-relaxed text-[#64748b]" }
const _hoisted_71 = { class: "flex items-center justify-end gap-2 pt-2 border-t border-[#f1f5f9]" }

import { ref, computed, watch, onMounted } from "vue";
import {
  Sparkles,
  X,
  ChevronDown,
  Volume2,
  Save,
  Loader2,
  AlertTriangle,
  AlertCircle,
  Info,
  History,
  RotateCcw,
  LayoutGrid,
} from "lucide-vue-next";
import { useToast } from "vue-toast-notification";
import { aiSectionEditService } from "@/services/aiSectionEditService";
import type { AiModelItem, AiSectionHistoryItem } from "@/types/aiEditor";


export default /*@__PURE__*/_defineComponent({
  __name: 'AiSectionEditorDrawer',
  props: {
    open: { type: Boolean },
    reportId: {},
    clientId: {},
    sectionKey: {},
    sectionLabel: {},
    isPublished: { type: Boolean }
  },
  emits: ["update:open", "section-updated"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const toast = useToast();

const availableModels = ref<AiModelItem[]>([]);
const selectedModelId = ref<string>("gpt-4o-mini");
const showBrandVoice = ref(false);
const brandVoice = ref("");
const savingBrandVoice = ref(false);

const promptText = ref("");
const isProcessing = ref(false);
const isEnhancing = ref(false);
const originalPromptBeforeEnhance = ref<string | null>(null);
const processingStatusMessage = ref("Queueing revision job...");
const errorMessage = ref<string | null>(null);
const fallbackNotice = ref<string | null>(null);

const history = ref<AiSectionHistoryItem[]>([]);
const loadingHistory = ref(false);

const confirmDialog = ref<{
  show: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  confirmVariant: "primary" | "danger" | "warning";
  onConfirm: (() => void) | null;
}>({
  show: false,
  title: "",
  description: "",
  confirmLabel: "Confirm",
  confirmVariant: "primary",
  onConfirm: null,
});

function openConfirm(options: {
  title: string;
  description: string;
  confirmLabel: string;
  confirmVariant?: "primary" | "danger" | "warning";
  onConfirm: () => void;
}) {
  confirmDialog.value = {
    show: true,
    title: options.title,
    description: options.description,
    confirmLabel: options.confirmLabel,
    confirmVariant: options.confirmVariant || "primary",
    onConfirm: options.onConfirm,
  };
}

function handleConfirmAction() {
  confirmDialog.value.show = false;
  const action = confirmDialog.value.onConfirm;
  if (action) {
    action();
  }
}

const narrativeChips = [
  "Make it punchy & concise",
  "Highlight ROI & wins",
  "Executive tone",
  "Growth strategy",
  "Simplify jargon",
];

const designChips = [
  {
    label: "2-Column Split",
    prompt: "redesign the UI, I want you to place the deliverable cards on the left side and the progress, insight, and recommendation on the right side. so it will be 2 columns",
  },
  {
    label: "Dark Luxury Theme",
    prompt: "change the theme for this section to a sleek dark navy luxury theme with vibrant accents",
  },
  {
    label: "Add Milestone Banner",
    prompt: "add a success highlight banner at the top showing: 'Milestone Achieved: All promotional collateral produced and approved on schedule'",
  },
  {
    label: "Default Layout",
    prompt: "reset the section layout back to the standard default grid",
  },
];

const sectionTitle = computed(() => {
  if (props.sectionLabel) return props.sectionLabel;
  return props.sectionKey
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());
});

const openAiModels = computed(() =>
  availableModels.value.filter((m) => m.provider === "openai")
);
const ollamaModels = computed(() =>
  availableModels.value.filter((m) => m.provider === "ollama")
);
const hasOllama = computed(() => ollamaModels.value.length > 0);

const hasActiveOverride = computed(() =>
  history.value.some((h) => h.is_active)
);

function applyQuickChip(chip: string) {
  if (!promptText.value.trim()) {
    promptText.value = chip;
  } else {
    promptText.value = `${promptText.value.trim()}. ${chip}`;
  }
}

function handleClose() {
  if (isProcessing.value) {
    openConfirm({
      title: "Cancel Revision?",
      description: "AI revision is currently in progress. Closing the editor will abandon this prompt.",
      confirmLabel: "Close Anyway",
      confirmVariant: "danger",
      onConfirm: () => emit("update:open", false),
    });
    return;
  }
  emit("update:open", false);
}

async function loadModels() {
  try {
    const res = await aiSectionEditService.getModels();
    availableModels.value = res.models || [];
    if (res.default_model && !selectedModelId.value) {
      selectedModelId.value = res.default_model;
    }
  } catch {
    availableModels.value = [
      { id: "gpt-4o-mini", name: "GPT-4o Mini (Fast)", provider: "openai", is_available: true },
      { id: "gpt-4o", name: "GPT-4o (High Quality)", provider: "openai", is_available: true },
      { id: "llama3:8b", name: "llama3:8b", provider: "ollama", is_available: true },
      { id: "gemma3:4b", name: "gemma3:4b", provider: "ollama", is_available: true },
      { id: "qwen2.5:7b", name: "qwen2.5:7b", provider: "ollama", is_available: true },
      { id: "llama3.1:8b", name: "llama3.1:8b", provider: "ollama", is_available: true },
      { id: "mistral:7b-instruct", name: "mistral:7b-instruct", provider: "ollama", is_available: true },
    ];
  }
}

async function loadBrandVoice() {
  if (!props.clientId) return;
  try {
    brandVoice.value = await aiSectionEditService.getBrandVoice(props.clientId);
  } catch {
    brandVoice.value = "";
  }
}

async function saveBrandVoice() {
  if (!props.clientId) return;
  savingBrandVoice.value = true;
  try {
    await aiSectionEditService.updateBrandVoice(props.clientId, brandVoice.value);
    toast.success("Client Brand Voice saved!");
  } catch (err: any) {
    toast.error(err.response?.data?.message || "Failed saving brand voice");
  } finally {
    savingBrandVoice.value = false;
  }
}

async function loadHistory() {
  if (!props.reportId || !props.sectionKey) return;
  loadingHistory.value = true;
  try {
    history.value = await aiSectionEditService.getHistory(props.reportId, props.sectionKey);
  } catch {
    history.value = [];
  } finally {
    loadingHistory.value = false;
  }
}

async function handleApply() {
  if (!props.reportId || !props.sectionKey || !promptText.value.trim() || isProcessing.value) {
    return;
  }

  if (props.isPublished) {
    openConfirm({
      title: "Update Published Report?",
      description: "This report is published. Applying this AI revision will update the live client report and PDF immediately. Proceed?",
      confirmLabel: "Apply to Live Report",
      confirmVariant: "warning",
      onConfirm: () => void executeApply(),
    });
    return;
  }

  await executeApply();
}

async function executeApply() {
  if (!props.reportId || !props.sectionKey || !promptText.value.trim()) return;

  isProcessing.value = true;
  errorMessage.value = null;
  fallbackNotice.value = null;
  processingStatusMessage.value = "Submitting revision...";

  const selectedModel = availableModels.value.find((m) => m.id === selectedModelId.value);
  const provider = selectedModel?.provider || "openai";

  try {
    const queueRes = await aiSectionEditService.queueSectionEdit(
      props.reportId,
      props.sectionKey,
      {
        prompt: promptText.value.trim(),
        provider,
        model: selectedModelId.value,
      }
    );

    const runId = queueRes.run_id;
    processingStatusMessage.value = "Consulting AI engine...";

    let pollCount = 0;
    const maxPolls = 60;
    const interval = setInterval(async () => {
      pollCount++;
      try {
        const run = await aiSectionEditService.pollRun(runId);

        if (run.status === "running") {
          processingStatusMessage.value = "Generating and validating section text...";
        }

        if (run.status === "succeeded") {
          clearInterval(interval);
          isProcessing.value = false;
          promptText.value = "";

          if (run.fallback_used && run.used_model) {
            fallbackNotice.value = `Requested model was unavailable. ${run.used_model} was automatically used.`;
          }

          toast.success("Section revised successfully!");
          emit("section-updated", props.sectionKey);
          await loadHistory();
        } else if (run.status === "failed") {
          clearInterval(interval);
          isProcessing.value = false;
          errorMessage.value = run.error_message || "Revision failed to complete.";
        } else if (pollCount >= maxPolls) {
          clearInterval(interval);
          isProcessing.value = false;
          errorMessage.value = "AI revision timed out. Please try again.";
        }
      } catch (err: any) {
        clearInterval(interval);
        isProcessing.value = false;
        errorMessage.value = err.response?.data?.message || "Failed communicating with server.";
      }
    }, 1500);
  } catch (err: any) {
    isProcessing.value = false;
    errorMessage.value = err.response?.data?.message || "Could not start revision.";
  }
}

async function handleUndo() {
  if (!props.reportId || !props.sectionKey || isProcessing.value) return;
  isProcessing.value = true;
  try {
    const res = await aiSectionEditService.undo(props.reportId, props.sectionKey);
    toast.success(res.message || "Reverted successfully!");
    emit("section-updated", props.sectionKey);
    await loadHistory();
  } catch (err: any) {
    toast.error(err.response?.data?.message || "Failed undoing edit.");
  } finally {
    isProcessing.value = false;
  }
}

function handleReset() {
  if (!props.reportId || !props.sectionKey || isProcessing.value) return;
  openConfirm({
    title: "Reset Section to Original?",
    description: "Are you sure you want to reset this section to the original generated report data? All AI edits for this section will be deactivated.",
    confirmLabel: "Reset to Original",
    confirmVariant: "danger",
    onConfirm: () => void executeReset(),
  });
}

async function executeReset() {
  if (!props.reportId || !props.sectionKey) return;
  isProcessing.value = true;
  try {
    const res = await aiSectionEditService.reset(props.reportId, props.sectionKey);
    toast.success(res.message || "Reset to original data.");
    emit("section-updated", props.sectionKey);
    await loadHistory();
  } catch (err: any) {
    toast.error(err.response?.data?.message || "Failed resetting section.");
  } finally {
    isProcessing.value = false;
  }
}

function handleUndoEnhance() {
  if (originalPromptBeforeEnhance.value !== null) {
    promptText.value = originalPromptBeforeEnhance.value;
    originalPromptBeforeEnhance.value = null;
    toast.info("Restored original prompt.");
  }
}

async function handleEnhancePrompt() {
  if (!promptText.value.trim() || !props.reportId || isProcessing.value || isEnhancing.value) return;
  isEnhancing.value = true;
  try {
    const rawPrompt = promptText.value;
    const enhanced = await aiSectionEditService.enhancePrompt(
      props.reportId,
      props.sectionKey,
      rawPrompt,
      undefined,
      selectedModelId.value
    );
    if (enhanced && enhanced.trim()) {
      originalPromptBeforeEnhance.value = rawPrompt;
      promptText.value = enhanced.trim();
      toast.success("Prompt enhanced with AI!", { position: "top-right" });
    }
  } catch (err: any) {
    toast.error(err?.response?.data?.message || "Failed to enhance prompt.", { position: "top-right" });
  } finally {
    isEnhancing.value = false;
  }
}

function handleRestoreVersion(version: number) {
  if (!props.reportId || !props.sectionKey || isProcessing.value) return;
  openConfirm({
    title: `Restore Version ${version}?`,
    description: `This will switch the active section content, layout, and theme to Version ${version}.`,
    confirmLabel: `Restore Version ${version}`,
    confirmVariant: "primary",
    onConfirm: async () => {
      isProcessing.value = true;
      processingStatusMessage.value = `Restoring Version ${version}...`;
      try {
        const res = await aiSectionEditService.restoreVersion(props.reportId!, props.sectionKey, version);
        toast.success(res.message || `Restored to Version ${version}`, { position: "top-right" });
        emit("section-updated", props.sectionKey);
        await loadHistory();
      } catch (err: any) {
        toast.error(err?.response?.data?.message || "Failed to restore version.", { position: "top-right" });
      } finally {
        isProcessing.value = false;
      }
    },
  });
}

function formatDate(isoDate?: string): string {
  if (!isoDate) return "";
  try {
    const d = new Date(isoDate);
    return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) + " " + d.toLocaleDateString([], { month: "short", day: "numeric" });
  } catch {
    return isoDate;
  }
}

watch(
  () => [props.open, props.sectionKey],
  ([val]) => {
    if (val) {
      loadModels();
      loadBrandVoice();
      loadHistory();
      errorMessage.value = null;
      fallbackNotice.value = null;
    }
  }
);

onMounted(() => {
  if (props.open) {
    loadModels();
    loadBrandVoice();
    loadHistory();
  }
});

return (_ctx: any,_cache: any) => {
  return (__props.open)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(Sparkles), { class: "h-4.5 w-4.5 animate-pulse" })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(sectionTitle.value), 1),
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-[11px] text-[#64748b]" }, " Revise section narrative with AI ", -1))
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "flex h-8 w-8 items-center justify-center rounded-xl text-[#64748b] hover:bg-[#e2e8f0] hover:text-[#0f172a] transition shrink-0",
            title: "Close AI Editor",
            onClick: handleClose
          }, [
            _createVNode(_unref(X), { class: "h-4 w-4" })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (__props.isPublished)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_unref(AlertCircle), { class: "h-4 w-4 text-amber-600 shrink-0 mt-0.5" }),
                _cache[7] || (_cache[7] = _createElementVNode("div", null, [
                  _createElementVNode("span", { class: "font-bold" }, "Published Report:"),
                  _createTextVNode(" Revisions applied here will update the live report document and PDF. ")
                ], -1))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "text-[11px] font-extrabold text-[#334155] uppercase tracking-wider" }, " AI Engine & Model ", -1)),
              (hasOllama.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("span", { class: "h-1.5 w-1.5 rounded-full bg-emerald-500 animate-ping" }, null, -1),
                    _createTextVNode(" Ollama Online ", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedModelId).value = $event)),
                disabled: isProcessing.value,
                class: "w-full appearance-none rounded-xl border border-[#cbd5e1] bg-white px-3 py-2 text-xs font-semibold text-[#0f172a] shadow-sm transition focus:border-[#2563eb] focus:outline-none focus:ring-2 focus:ring-[#2563eb]/20 disabled:bg-slate-50"
              }, [
                (openAiModels.value.length > 0)
                  ? (_openBlock(), _createElementBlock("optgroup", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(openAiModels.value, (m) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: m.id,
                          value: m.id
                        }, _toDisplayString(m.name), 9, _hoisted_15))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (ollamaModels.value.length > 0)
                  ? (_openBlock(), _createElementBlock("optgroup", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ollamaModels.value, (m) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: m.id,
                          value: m.id
                        }, _toDisplayString(m.name), 9, _hoisted_17))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_13), [
                [_vModelSelect, selectedModelId.value]
              ]),
              _createVNode(_unref(ChevronDown), { class: "pointer-events-none absolute right-3 top-2.5 h-3.5 w-3.5 text-[#64748b]" })
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              type: "button",
              class: "flex w-full items-center justify-between px-3.5 py-2.5 text-left text-xs font-bold text-[#334155] hover:bg-[#f1f5f9] transition",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showBrandVoice.value = !showBrandVoice.value))
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_unref(Volume2), { class: "h-3.5 w-3.5 text-[#2563eb]" }),
                _cache[10] || (_cache[10] = _createElementVNode("span", null, "Brand Voice & Tone", -1)),
                (brandVoice.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Custom"))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(ChevronDown), {
                class: _normalizeClass(["h-3.5 w-3.5 text-[#64748b] transition-transform duration-200", { 'rotate-180': showBrandVoice.value }])
              }, null, 8, ["class"])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((brandVoice).value = $event)),
                rows: "2",
                maxlength: "500",
                placeholder: "e.g. Formal tone, emphasize ROI, avoid jargon.",
                class: "w-full rounded-lg border border-[#cbd5e1] p-2 text-xs text-[#0f172a] focus:border-[#2563eb] focus:outline-none focus:ring-1 focus:ring-[#2563eb]"
              }, null, 512), [
                [_vModelText, brandVoice.value]
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("button", {
                  type: "button",
                  disabled: savingBrandVoice.value,
                  class: "inline-flex items-center gap-1 rounded-lg bg-[#0f3557] px-2.5 py-1 text-[11px] font-bold text-white transition hover:bg-[#1a4a6e] disabled:opacity-50",
                  onClick: saveBrandVoice
                }, [
                  _createVNode(_unref(Save), { class: "h-3 w-3" }),
                  _createElementVNode("span", null, _toDisplayString(savingBrandVoice.value ? 'Saving...' : 'Save Tone'), 1)
                ], 8, _hoisted_23)
              ])
            ], 512), [
              [_vShow, showBrandVoice.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", null, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "text-[10px] font-extrabold text-[#64748b] uppercase tracking-wider block mb-1" }, " Writing & Content ", -1)),
              _createElementVNode("div", _hoisted_25, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(narrativeChips, (chip, idx) => {
                  return _createElementVNode("button", {
                    key: 'narrative-' + idx,
                    type: "button",
                    disabled: isProcessing.value,
                    class: "inline-flex items-center gap-1 rounded-lg border border-[#d8e4f0] bg-white px-2 py-1 text-[11px] font-semibold text-[#334155] transition hover:border-[#2563eb] hover:bg-[#eff6ff] hover:text-[#2563eb] active:scale-95 disabled:opacity-50",
                    onClick: ($event: any) => (applyQuickChip(chip))
                  }, [
                    _createVNode(_unref(Sparkles), { class: "h-2.5 w-2.5 text-[#2563eb]" }),
                    _createElementVNode("span", null, _toDisplayString(chip), 1)
                  ], 8, _hoisted_26)
                }), 64))
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "text-[10px] font-extrabold text-[#64748b] uppercase tracking-wider block mb-1" }, " Design, Layout & Themes ", -1)),
              _createElementVNode("div", _hoisted_27, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(designChips, (chip, idx) => {
                  return _createElementVNode("button", {
                    key: 'design-' + idx,
                    type: "button",
                    disabled: isProcessing.value,
                    class: "inline-flex items-center gap-1 rounded-lg border border-[#e0e7ff] bg-[#faf5ff] px-2 py-1 text-[11px] font-semibold text-[#6b21a8] transition hover:border-[#7c3aed] hover:bg-[#f3e8ff] hover:text-[#7c3aed] active:scale-95 disabled:opacity-50",
                    onClick: ($event: any) => (applyQuickChip(chip.prompt || chip.label))
                  }, [
                    _createVNode(_unref(LayoutGrid), { class: "h-2.5 w-2.5 text-[#7c3aed]" }),
                    _createElementVNode("span", null, _toDisplayString(chip.label), 1)
                  ], 8, _hoisted_28)
                }), 64))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "text-[11px] font-extrabold text-[#334155] uppercase tracking-wider" }, " Revision Prompt ", -1)),
              _createElementVNode("span", _hoisted_31, _toDisplayString(promptText.value.length) + "/1000 ", 1)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                (originalPromptBeforeEnhance.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "inline-flex items-center gap-1 rounded-lg bg-slate-100 hover:bg-slate-200 border border-slate-300 px-2 py-1 text-[10px] font-semibold text-slate-700 shadow-xs transition active:scale-95",
                      title: "Undo enhanced prompt and revert to original",
                      onClick: handleUndoEnhance
                    }, [
                      _createVNode(_unref(RotateCcw), { class: "h-2.5 w-2.5 text-slate-500" }),
                      _cache[14] || (_cache[14] = _createElementVNode("span", null, "Undo", -1))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  disabled: isProcessing.value || isEnhancing.value || !promptText.value.trim(),
                  class: "inline-flex items-center gap-1 rounded-lg bg-gradient-to-r from-[#2563eb] to-[#7c3aed] px-2.5 py-1 text-[10.5px] font-bold text-white shadow-xs transition hover:opacity-95 active:scale-95 disabled:opacity-30 disabled:pointer-events-none",
                  title: "Improve prompt with AI",
                  onClick: handleEnhancePrompt
                }, [
                  (!isEnhancing.value)
                    ? (_openBlock(), _createBlock(_unref(Sparkles), {
                        key: 0,
                        class: "h-3 w-3 text-amber-300"
                      }))
                    : (_openBlock(), _createBlock(_unref(Loader2), {
                        key: 1,
                        class: "h-3 w-3 animate-spin"
                      })),
                  _createElementVNode("span", null, _toDisplayString(isEnhancing.value ? 'Enhancing...' : 'Enhance'), 1)
                ], 8, _hoisted_34)
              ]),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((promptText).value = $event)),
                rows: "3",
                maxlength: "1000",
                disabled: isProcessing.value,
                placeholder: "What should be revised in this section? (e.g. 2 columns with cards on left, or dark luxury theme)",
                class: "w-full rounded-xl border border-[#cbd5e1] p-3 pr-28 text-xs text-[#0f172a] shadow-sm transition placeholder:text-[#94a3b8] focus:border-[#2563eb] focus:outline-none focus:ring-2 focus:ring-[#2563eb]/20 disabled:bg-slate-50",
                onKeydown: [
                  _withKeys(_withModifiers(handleApply, ["ctrl"]), ["enter"]),
                  _withKeys(_withModifiers(handleApply, ["meta"]), ["enter"])
                ]
              }, null, 40, _hoisted_35), [
                [_vModelText, promptText.value]
              ])
            ])
          ]),
          (isProcessing.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createVNode(_unref(Loader2), { class: "h-4 w-4 animate-spin text-[#2563eb] shrink-0" }),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", null, _toDisplayString(processingStatusMessage.value), 1),
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "mt-0.5 text-[10px] font-normal text-[#3b82f6]" }, " Validating numbers and updating preview ", -1))
                ])
              ]))
            : _createCommentVNode("", true),
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createVNode(_unref(AlertTriangle), { class: "h-4 w-4 text-red-600 shrink-0 mt-0.5" }),
                _createElementVNode("div", _hoisted_39, [
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "font-bold" }, " Revision Failed ", -1)),
                  _createElementVNode("div", _hoisted_40, _toDisplayString(errorMessage.value), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "text-red-600 hover:text-red-900",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (errorMessage.value = null))
                }, [
                  _createVNode(_unref(X), { class: "h-3.5 w-3.5" })
                ])
              ]))
            : _createCommentVNode("", true),
          (fallbackNotice.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createVNode(_unref(Info), { class: "h-4 w-4 text-amber-600 shrink-0 mt-0.5" }),
                _createElementVNode("div", _hoisted_42, [
                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "font-bold" }, "Provider Fallback:", -1)),
                  _createTextVNode(" " + _toDisplayString(fallbackNotice.value), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_unref(History), { class: "h-3 w-3 text-[#64748b]" }),
                _cache[18] || (_cache[18] = _createElementVNode("span", null, "Version History", -1))
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("button", {
                  type: "button",
                  disabled: isProcessing.value || history.value.length <= 0,
                  class: "text-[10.5px] font-bold text-[#dc2626] hover:underline disabled:opacity-40",
                  onClick: handleReset
                }, " Reset to Original ", 8, _hoisted_47)
              ])
            ]),
            (loadingHistory.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, " Loading history... "))
              : (history.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, " Original report data (no revisions yet) "))
                : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(history.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id,
                        class: _normalizeClass(["flex items-center justify-between rounded-lg border p-2 text-xs transition", item.is_active ? 'border-[#2563eb] bg-[#f0f7ff]' : 'border-[#e2e8f0] bg-white opacity-70'])
                      }, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("span", null, "Version " + _toDisplayString(item.version), 1),
                            (item.is_active)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_53, "Active"))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_54, "via " + _toDisplayString(item.model || item.provider || 'AI'), 1)
                          ]),
                          _createElementVNode("div", {
                            class: "text-[10.5px] text-[#64748b] truncate",
                            title: item.prompt
                          }, " \"" + _toDisplayString(item.prompt) + "\" ", 9, _hoisted_55)
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          (!item.is_active)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                disabled: isProcessing.value,
                                class: "inline-flex items-center gap-1 rounded-md border border-[#cbd5e1] bg-white px-2 py-0.5 text-[10px] font-bold text-[#0f3557] shadow-2xs transition hover:border-[#2563eb] hover:bg-[#eff6ff] hover:text-[#2563eb] active:scale-95 disabled:opacity-40",
                                title: "Restore to this version",
                                onClick: ($event: any) => (handleRestoreVersion(item.version))
                              }, [
                                _createVNode(_unref(RotateCcw), { class: "h-2.5 w-2.5 text-[#2563eb]" }),
                                _cache[19] || (_cache[19] = _createElementVNode("span", null, "Restore", -1))
                              ], 8, _hoisted_57))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_58, _toDisplayString(formatDate(item.created_at)), 1)
                        ])
                      ], 2))
                    }), 128))
                  ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            (hasActiveOverride.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  disabled: isProcessing.value,
                  class: "inline-flex items-center gap-1 rounded-xl border border-[#cbd5e1] bg-white px-3 py-2 text-xs font-bold text-[#334155] shadow-sm hover:bg-[#f1f5f9] transition active:scale-95 disabled:opacity-50",
                  onClick: handleUndo
                }, [
                  _createVNode(_unref(RotateCcw), { class: "h-3 w-3" }),
                  _cache[20] || (_cache[20] = _createElementVNode("span", null, "Undo", -1))
                ], 8, _hoisted_61))
              : (_openBlock(), _createElementBlock("div", _hoisted_62)),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("button", {
                type: "button",
                class: "rounded-xl px-3 py-2 text-xs font-bold text-[#64748b] hover:text-[#0f172a] transition",
                onClick: handleClose
              }, " Cancel "),
              _createElementVNode("button", {
                type: "button",
                disabled: isProcessing.value || !promptText.value.trim(),
                class: "inline-flex items-center gap-1.5 rounded-xl bg-gradient-to-r from-[#0f3557] to-[#2563eb] px-4 py-2 text-xs font-bold text-white shadow-sm transition hover:brightness-110 active:scale-95 disabled:opacity-50 disabled:pointer-events-none",
                onClick: handleApply
              }, [
                _createVNode(_unref(Sparkles), { class: "h-3.5 w-3.5" }),
                _createElementVNode("span", null, _toDisplayString(isProcessing.value ? 'Revising...' : 'Apply Revision'), 1)
              ], 8, _hoisted_64)
            ])
          ])
        ]),
        _createVNode(_Transition, {
          "enter-active-class": "transition duration-200 ease-out",
          "enter-from-class": "opacity-0 scale-95",
          "enter-to-class": "opacity-100 scale-100",
          "leave-active-class": "transition duration-150 ease-in",
          "leave-from-class": "opacity-100 scale-100",
          "leave-to-class": "opacity-0 scale-95"
        }, {
          default: _withCtx(() => [
            (confirmDialog.value.show)
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex h-9 w-9 shrink-0 items-center justify-center rounded-xl", confirmDialog.value.confirmVariant === 'danger' ? 'bg-red-50 text-red-600 border border-red-200' : 'bg-amber-50 text-amber-600 border border-amber-200'])
                      }, [
                        _createVNode(_unref(AlertTriangle), { class: "h-5 w-5" })
                      ], 2),
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("h4", _hoisted_69, _toDisplayString(confirmDialog.value.title), 1),
                        _createElementVNode("p", _hoisted_70, _toDisplayString(confirmDialog.value.description), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "rounded-xl px-3 py-1.5 text-xs font-semibold text-[#64748b] hover:bg-[#f1f5f9] hover:text-[#0f172a] transition",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (confirmDialog.value.show = false))
                      }, " Cancel "),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["rounded-xl px-3.5 py-1.5 text-xs font-bold text-white shadow-sm transition active:scale-95", confirmDialog.value.confirmVariant === 'danger' ? 'bg-red-600 hover:bg-red-700' : 'bg-[#0f3557] hover:bg-[#1a4a6e]']),
                        onClick: handleConfirmAction
                      }, _toDisplayString(confirmDialog.value.confirmLabel), 3)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})